module.exports = __webpack_public_path__ + "img/pro-p-slider3.f8b45821.png";